import styled, { css } from 'styled-components';

import Text from 'components/Text';

export const MarginBottom = styled.div`
  margin-bottom: 16px;
`;

export const OrderContain = styled.div`
  background-color: rgb(241, 245, 247);
`;

export const Chip = styled.div`
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  padding: 12px;
  padding-right: 24px;
  padding-left: 24px;
  border-radius: 2px;
  border-style: solid;
  border-width: 1px;
  border-color: '#ffffffc2';
`;

export const HeaderFlex = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
`;

export const FlexRight = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
`;

export const HeaderFlexItem = styled.div`
  flex: ${(props) => (props.flex !== undefined ? props.flex : 1)};

  ${({ right }) =>
    right &&
    css`
      display: flex;
      align-items: center;
      justify-content: flex-end;
    `};
`;

export const Notice = styled.div`
  flex: 1;
  display: flex;
  padding: 8px;
  margin-top: 16px;
  border-radius: 3px;
  font-family: 'Roboto';
  align-items: center;
  justify-content: center;
  box-shadow: inset 0px 0px 0px ${(props) => (props.strong ? 2 : 1)}px
    ${(props) => props.color};
  background-color: ${(props) => props.lightColor};

  ${(props) => props.theme.media.sm.max`
    padding: 12px;
  `}
`;

export const OrdersContainer = styled.div``;

export const MarginRight = styled.div`
  margin-right: 8px;
`;

export const NoticeText = styled(Text.Default)`
  ${(props) => props.theme.media.sm.max`
    font-size: 0.8em;
    line-height: 1.5em;
  `}
`;
